import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';

import { CAMPAIGN_OWNER, CAMPAIGN_ADMIN, TEAM_MEMBER, CLIENT, INFLUENCER } from '../../utils/static-configuration';
import { checkUserHasAdminRights } from '../../utils/role-service';
import { removeMember, removePendingMember } from './actions';
import Member from '../../components/member';

class CampaignMembersManage extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  componentDidMount() {
    // Users must navigate to this page from a valid campaign
    const campaignExist = this.props.campaign.size > 0;
    if (!campaignExist) {
      this.context.router.push('/');
    }

    if (!checkUserHasAdminRights(this.props.myUserRole)) {
      this.context.router.push('/');
    }
  }

  deleteMember(member) {
    const permissionId = member.get('id');
    const userId = member.getIn(['user', 'id']);
    const role = member.get('role');

    // Campaign owners cant be deleted
    if (role === CAMPAIGN_OWNER) {
      return null;
    }

    this.props.onRemoveMember(permissionId, userId);
  }

  deletePendingMember(member) {
    const invitationId = member.get('id');

    this.props.onRemovePendingMember(invitationId);
  }

  render() {
    const { campaign, members, pendingInvitations } = this.props;

    const campaignName = campaign.get('name');
    const campaignString = `/campaign/${campaign.get('id')}`;

    const teamMembers = [];
    const clientMembers = [];
    const influencerMembers = [];

    if (members) {
      members.forEach(member => {
        const role = member.get('role');

        if (role === TEAM_MEMBER || role === CAMPAIGN_OWNER || role === CAMPAIGN_ADMIN) teamMembers.push(member);
        if (role === CLIENT) clientMembers.push(member);
        if (role === INFLUENCER) influencerMembers.push(member);
      });
    }

    let totalPendingInvitations = 0;
    pendingInvitations.forEach(organisation => totalPendingInvitations += organisation.size);

    return (
      <div className="page">
        <div className="page-content">
          <div className="grid">
            <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
              <div className="breadcrumb-bar">
                <img src="/icons/chevron-left.svg" alt="back to campaign" onClick={() => this.context.router.push(`${campaignString}`)} />
                <h3 onClick={() => this.context.router.push(`${campaignString}`)}>
                  {campaignName}
                </h3>
              </div>
            </div>
            <div className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6">
              <div className="hero left">
                <h1>Manage people</h1>
              </div>
            </div>
            <div className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6">
              <div className="hero action right">
                <button className="medium icon" onClick={() => this.context.router.push('/campaign/members')}>
                  <p>Invite people</p>
                  <img src="/icons/add-person.svg" alt="Invite people" />
                </button>
              </div>
            </div>
            { teamMembers.length > 0 &&
              <span>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3>Team ({teamMembers.length})</h3>
                </div>
                { teamMembers.map(member => {
                  const teamMemberRole = member.get('role');

                  return (
                    <Member
                      key={member.get('id')}
                      deleteMember={this.deleteMember.bind(this, member)}
                      member={member}
                      deletable={teamMemberRole !== CAMPAIGN_OWNER}
                    />
                  );
                })}
              </span>
            }
            { clientMembers.length > 0 &&
              <span>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="spacer" />
                </div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3>Clients ({clientMembers.length})</h3>
                </div>
                { clientMembers.map(member => (
                  <Member
                    key={member.get('id')}
                    deleteMember={this.deleteMember.bind(this, member)}
                    member={member}
                    deletable
                  />
                  ))}
              </span>
            }
            { influencerMembers.length > 0 &&
              <span>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="spacer" />
                </div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3>Influencers ({influencerMembers.length})</h3>
                </div>
                { influencerMembers.map(member => (
                  <Member
                    key={member.get('id')}
                    deleteMember={this.deleteMember.bind(this, member)}
                    member={member}
                    deletable
                  />
                  ))}
              </span>
            }
            { pendingInvitations.size > 0 &&
              <span>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="spacer" />
                </div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3>Pending invites ({totalPendingInvitations})</h3>
                </div>
                { pendingInvitations.map(organisation => organisation.map(member => (
                  <Member
                    key={member.get('id')}
                    deleteMember={this.deletePendingMember.bind(this, member)}
                    member={member}
                    pendingInvites
                    deletable
                  />
                    )))}
              </span>
            }
          </div>
        </div>
      </div>
    );
  }
}

CampaignMembersManage.propTypes = {
  routeParams: React.PropTypes.object,
};

const mapStateToProps = state => ({
  campaign: state.campaign.get('campaign'),
  myUserRole: state.campaign.get('myUserRole'),
  members: state.members.get('members'),
  pendingInvitations: state.members.get('pendingInvitations'),
  removeMemberLoading: state.members.get('removeMemberLoading'),
  removeMemberError: state.members.get('removeMemberError'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onRemoveMember: (permissionId, userId) => dispatch(removeMember(permissionId, userId)),
    onRemovePendingMember: invitationId => dispatch(removePendingMember(invitationId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  CampaignMembersManage,
);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-members-manage/index.js
 **/